<template>
  <div class="EventFlow">
    <ul v-infinite-scroll="init">
      <li v-for="item in initList" :key="item.guid">
        <div class="time">{{ formatTime(item.localTime) }}</div>
        <div class="_icon"><i class="spot"></i><i class="line"></i></div>
        <div class="event-info">
          {{ getEventTypeText(item.serviceNumber) }} {{ getStatusText(item.status) }} {{ getDetailsText(item) }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import {
  getCastMirrorEventsList
} from "@/api/rabbit/detail";
import OptionList from './ServiceOption'
export default {
  props: {
    // 业务类型：push-推送，mirror-镜像
    castType: {
      type: String,
      default: 'mirror'
    },
    // 新增uri和pdate参数
    uri: {
      type: String,
      default: ''
    },
    pdate: {
      type: String,
      default: ''
    },
    // 新增serviceType参数
    serviceType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      optionList: OptionList,
      initList: [],
      current: 0,
      total: 1,
    }
  },
  watch: {
    '$route.path': {
      handler(val) {
        if (val === '/imageManagement/mirrorUserDetails') {
          this.current = 0
          this.initList = []
          this.init()
        }
      },
      deep: true
    },
  },
  methods: {
    // 获取特定serviceType的事件映射
    // serviceType: 1-投屏事件, 2-镜像事件, 100-广告事件
    getEventTypeMapByServiceType(serviceType) {
      const eventTypeMaps = {
        '100': { // 广告事件 (Ad Events) - 只有三个事件
          '102': '结束前贴广告播放',
          '100': '前贴广告播放结果',
          '3': '请求前贴广告结果'
         }
      };
      
      return eventTypeMaps[serviceType] || null;
    },

    setDate(time) {
      const date = new Date(parseInt(time))
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds();
      return `${hour < 10 ? '0' + hour : hour}: ${minute < 10 ? '0' + minute : minute}: ${second < 10 ? '0' + second : second}`
    },

    // 格式化时间字符串
    formatTime(timeStr) {
      if (!timeStr) return '-';
      // 将 "2025-08-06 22:54:20" 格式完整显示
      return timeStr;
    },

    // 获取状态文本
    getStatusText(status) {
      if (!status) return '';
      const statusMap = {
        1: '成功',
        2: '失败'
      };
      return statusMap[status] || '';
    },

    // 获取状态样式类
    getStatusClass(status) {
      return {
        'status-success': status === 1,
        'status-failed': status === 2
      };
    },

    // 获取事件类型描述
    // serviceType: 1-投屏事件, 2-镜像事件, 100-广告事件
    getEventTypeText(serviceNumber) {
      // 付费弹窗场景判断
        if (serviceNumber === 'response_norights' && this.serviceType === 'cast_vip_tv') {
            return `付费弹窗-后台api (sn=${serviceNumber})`;
      }
      
        if (this.serviceType === 'app_vip' && serviceNumber === 'vip_order_page_load_tv') {
            return `付费弹窗-客户端上报 (sn=${serviceNumber})`;
      }
      
      // 根据serviceType获取特定的事件映射
      if (this.serviceType) {
        const specificEventMap = this.getEventTypeMapByServiceType(this.serviceType);
        if (specificEventMap && specificEventMap[serviceNumber]) {
          const eventText = specificEventMap[serviceNumber];
          return `${eventText}(sn=${serviceNumber})`;
        }
      }
      
      // 默认的事件类型映射（serviceType=1或2时的逻辑）
      const eventTypeMap = {
        // 发送端事件
        1: '发送端-收到APP投屏推送',
        2: '发送端-投屏推送至接收端',
        108: '发送端-获取收端播放结果',
        201: '发送端-异常断开请求',
        204: '发送端-请求重连/重试',
        205: '发送端-投屏环境变化',
        110: '发送端-结束投屏',
        
        // 接收端事件
        3: '接收端-收到投屏请求',
        4: '接收端-追加剧集',
        70: '接收端-启动播放界面',
        80: '接收端-加载url',
        90: '接收端-解码第一帧',
        100: '接收端-播放结果',
        103: '接收端-黑屏检测结果',
        202: '接收端-异常断开',
        203: '接收端-重连/重试结果',
        102: '接收端-退出投屏'
      };
      
      const eventText = eventTypeMap[serviceNumber] || `未知事件`;
      return `${eventText}(sn=${serviceNumber})`;
    },

    getDetailsText(item) {
      const details = [];
      
      // 当serviceNumber=102（退出投屏）或110（主动结束投屏）时，优先显示exitType和exitCode
      if (item.serviceNumber === '102' || item.serviceNumber === '110') {
        if (item.exitType) {
          const exitTypeText = this.getExitTypeText(item.exitType);
          if (exitTypeText) {
            details.push(`exitType:${item.exitType}(${exitTypeText})`);
          } else {
            details.push(`exitType:${item.exitType}`);
          }
        }
        if (item.exitCode) {
          const exitCodeText = this.getExitCodeText(item.exitCode);
          if (exitCodeText) {
            details.push(`exitCode:${item.exitCode}(${exitCodeText})`);
          } else {
            details.push(`exitCode:${item.exitCode}`);
          }
        }
      }
      
      // 其他情况按优先级显示错误信息
      if (item.errorCode) {
        const errorCodeText = this.getErrorCodeText(item.errorCode);
        if (errorCodeText) {
          details.push(`errorCode:${item.errorCode}(${errorCodeText})`);
        } else {
          details.push(`errorCode:${item.errorCode}`);
        }
      }
      if (item.errorType) {
        const errorTypeText = this.getErrorTypeText(item.errorType);
        if (errorTypeText) {
          details.push(`errorType:${item.errorType}(${errorTypeText})`);
        } else {
          details.push(`errorType:${item.errorType}`);
        }
      }
      if (item.errorMessage) {
        details.push(`errorMessage:${item.errorMessage}`);
      }
      if (item.networkCode) {
        details.push(`networkCode:${item.networkCode}`);
      }
      
      return details.length > 0 ? details.join(' ') : '';  
    },

    // 获取退出码大类中文说明
    getExitCodeText(exitCode) {
      const exitCodeMap = {
        '-1': '默认值',
        '-3': '默认值',
        '0': '默认值',
        '1': '正常退出',
        '2': '接收端检测到读数据超时且断开时',
        '3': '异常退出',
        '101': '接收端检测到被抢占',
        '102': '接收端用户按返回键back/主页键home退出',
        '103': '会议室项目iOS退出，需要特别区分',
        '104': '会议室项目HttpServer命令退出',
        '106': '前贴广告按返回键',
        '107': '防骚扰导致退出（拒绝、黑名单、超时）',
        '108': '播放器onError导致退出',
        '109': '播放器播放完成退出',
        '110': '其他应用抢占导致退出（如home键启动luncher）',
        '111': '协议内抢占（如乐播app本地相册切换图片）',
        '113': 'icense校验失败',
        '115': '播放广告过程退出(不包括按返回键，广告按返回键退出是106)',
        '116': '播放器播放成功前，正常退出（包括发端主动退出，云镜像房间断开退出等)',
        '117': '播放器播放成功前，接收端检测到读数据超时',
        '118': '播放器播放成功前，异常退出',
        '119': '播放器播放成功前，接收端检测到被抢占',
        '120': '播放器播放成功前，接收端用户按返回键back/主页键home退出',
        '121': '播放器播放成功前，其他应用抢占导致退出（如home键启动luncher）',
        '122': '列表推送url已过期',
        '123': 'Auth失败',
        '124': '投屏被忽略（url格式不支持播放、忽略两秒内的相同地址请求）',
        '125': '引流到第三方APP播放',
        '126': '投屏管控停止',
        '127': '人脸识别停止',
        '128': '引流设置页退出',
        '129': '安全播放退出',
        '130': '启动播放器Activity失败'
      };
      
      return exitCodeMap[exitCode] || '';
    },

    // 获取退出详情中文说明
    getExitTypeText(exitType) {
      const exitTypeMap = {
        '-1': '默认值',
        '0': '默认值',
        '101': '接收端检测到被抢占',
        '102': '接收端用户按返回键back/主页键home退出',
        '103': '会议室项目iOS退出，需要特别区分',
        '104': '会议室项目HttpServer命令退出',
        '106': '前贴广告按返回键',
        '107': '防骚扰导致退出（拒绝、黑名单、超时）',
        '108': '播放器onError导致退出',
        '109': '播放器播放完成退出',
        '110': '其他应用抢占导致退出（如home键启动luncher）',
        '111': '协议内抢占（如乐播app本地相册切换图片）',
        '113': 'icense校验失败',
        '115': '播放广告过程退出(不包括按返回键，广告按返回键退出是106)',
        '116': '播放器播放成功前，正常退出（包括发端主动退出，云镜像房间断开退出等)',
        '117': '播放器播放成功前，接收端检测到读数据超时',
        '118': '播放器播放成功前，异常退出',
        '119': '播放器播放成功前，接收端检测到被抢占',
        '120': '播放器播放成功前，接收端用户按返回键back/主页键home退出',
        '121': '播放器播放成功前，其他应用抢占导致退出（如home键启动luncher）',
        '122': '列表推送url已过期',
        '123': 'Auth失败',
        '124': '投屏被忽略（url格式不支持播放、忽略两秒内的相同地址请求）',
        '125': '引流到第三方APP播放',
        '126': '投屏管控停止',
        '127': '人脸识别停止',
        '128': '引流设置页退出',
        '129': '安全播放退出',
        '130': '启动播放器Activity失败',
        '400': '网络切换',
        '21333': 'lelink-fp用户主动断开镜像的control连接',
        '21334': 'lelink-fp镜像数据连接正常断开',
        '21335': 'lelink-fp镜像数据连接异常断开(一般不可能发生)',
        '21336': 'lelink-fp镜像数据连接超时断开',
        '21337': 'lelink-fp镜像数据连接异常断开(一般不可能发生)',
        '21338': 'lelink-fp镜像数据连接异常断开(一般不可能发生)',
        '21341': '乐联镜像正常断开(无使用)',
        '21342': '乐联镜像异常断开',
        '21343': '乐联镜像超时断开',
        '21345': '乐联镜像Server异常断开(一般不可能发生)',
        '21347': '用户请求关闭音频共享(lelink-fp or 乐联)',
        '21348': 'Audio server超时退出',
        '21349': 'Audio Server异常断开(一般不可能发生)',
        '21352': '用户请求停止url视频推送(lelink-fp及乐联都使用)',
        '21358': '用户请求停止图片推送(老版本lelink-fp及乐联使用)',
        '21361': '用户请求停止slideshow推送(老版本lelink-fp使用)',
        '21370': '请求停止音乐推送(乐联使用)',
        '21376': '请求关闭所有的播放器(钉钉乐联新增加需求)'
      };
      
      return exitTypeMap[exitType] || '';
    },

    // 获取错误码大类中文说明
    getErrorTypeText(errorType) {
      const errorTypeMap = {
        '100103001': '视频打开失败(系统播放器)',
        '100103002': '视频加载超时',
        '100103003': '不支持的视频格式',
        '100103300': '播放器异常：内存不足、无媒体文件头信息或头信息格式错误、无媒体文件数据流、获取播放器配置信息异常、数据读取中断',
        '100103301': '未知异常',
        '100103302': '服务器挂机',
        '100103303': '一般视频播放比较慢或视频本身有问题会引发',
        '100103304': '本地文件或网络错误',
        '100103305': '不符合相关编码标准和文件规范',
        '100103306': '符合相关编码标准和文件规范，但是media框架不支持',
        '100103307': '播放器加载超时',
        '100103320': '播放器黑屏错误',
        '100103321': '播放器SEEK超时错误',
        '100103308': '预留暂时无使用',
        '100103309': '创建锁失败',
        '100103310': '创建上下文失败',
        '100103311': '打开文件失败(一般是无法识别媒体头信息或网络不可达)',
        '100103312': '无法获取到音频或视频流信息',
        '100103313': '没有音频和视频流(一般是头部描述信息与流不匹配)',
        '100103314': '提取封面失败(如果视频流中包含封面但分配封面的视频帧出错)',
        '100103315': '读取音视频包错误',
        '100103316': '播放器停止(一般是超时或其他buffer出错等)',
        '100103317': '播放卡顿',
        '100103318': '黑屏有声音',
        '100103319': '音画不同步',
        '100103399': '切换播放器上报的事件',
        '100103100': '音乐播放失败',
        '100103101': '音乐加载超时',
        '100103200': '图片播放失败'
      };
      
      return errorTypeMap[errorType] || '';
    },

    // 获取错误详情中文说明
    getErrorCodeText(errorCode) {
      const errorCodeMap = {
        '3': 'url打开失败或格式解析失败',
        '100103002': '播放器加载超时',
        '10080091': '解码器queueInputBuffer异常',
        '10080081': '解码器configure异常',
        '10080072': '解码器createByCodecName异常',
        '10080013': '读取视频数据出现IO异常(超时或EIO)',
        '-403': 'http连接出现http 403',
        '10080082': '解码器start异常',
        '10080074': '提取sps/pps数据异常',
        '10080034': '云端配置关闭杜比音频',
        '10080035': '分配内存出错，无法创建ffmpeg codec',
        '-110': 'socket连接出现连接拒绝',
        '10080039': '分配内存出错，无法创建解码线程',
        '10080087': '分配内存出错，无法创建ffmpeg codec',
        '-404': 'http连接出现http 404',
        '10080088': 'ffmpeg解析sps异常',
        '10080037': '分配内存出错，无法创建解码线程',
        '-424': 'http连接出现http 424',
        '-429': 'http连接出现http 429',
        '10080027': '音频创建失败，声道超时最大支持范围'
      };
      
      return errorCodeMap[errorCode] || '';
    },

    async init() {
      if ( this.initList.length && this.initList.length >= this.total) return
      
      let params = {
        uri: this.uri || this.$route.query.uri,
        pdate: this.pdate || this.$route.query.pdate,
        current: ++this.current,
        size: 30,
        serviceType: this.serviceType // 传递serviceType参数
      }

      let res = await getCastMirrorEventsList(params)
      this.total = res.data.data.total

      this.initList.push(...res.data.data.records)
    }
  }
}
</script>

<style lang="scss" scoped>
.EventFlow {
  padding-top: 22px;
  font-size: 16px;
  color: #101010 100%;

  ul {
    max-height: 400px;
    overflow: auto;
    padding: 0;
    margin: 0;
    list-style: none;

    li {
      display: flex;
      align-items: flex-start;
      margin-bottom: 15px;
      padding: 0;
      gap: 20px;  /* 用空格分隔不同列 */

      .time {
        width: 200px;
        text-align: right;
        white-space: nowrap;
        overflow: visible;
        flex-shrink: 0;  /* 防止收缩 */
      }

      ._icon {
        width: 120px;
        text-align: center;
        position: relative;
        flex-shrink: 0;  /* 防止收缩 */

        .spot {
          position: absolute;
          top: 0px;
          left: 60px;
          display: inline-block;
          width: 6px;
          height: 6px;
          background-color: #1372e8;
          border-radius: 50%;
        }

        .line {
          position: absolute;
          top: 10px;
          left: 62px;
          display: inline-block;
          width: 2px;
          height: 22px;
          background-color: #1372e8;
        }
      }

      .event-info {
        flex: 1;
        word-break: break-word;
        white-space: normal;  /* 改为normal，优先在同一行显示 */
        line-height: 1.5;
        color: #101010;
        font-size: 14px;
        overflow-wrap: break-word;  /* 只有内容过长时才换行 */
      }
    }
  }
}
</style>